import { Card, Layout, Menu, Button, Row, Col, Popover, Input, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { CloseOutlined, MessageOutlined, EditOutlined, MenuOutlined, LogoutOutlined } from '@ant-design/icons';
const { Header, Footer, Sider, Content } = Layout;
const MainOutlet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [back, setBack] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [permission, setPermission] = useState(false);
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const titles = {
        // '/description/Component': '元件總覽',
    }
    const item = [
        // {
        //     key: '/description/Component',
        //     label: '元件總覽',
        //     children: [],
        // }
    ]
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const onSelect = (e) => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
        setCollapsed(false);
    }
    return (
        <>
            <Layout className="layout" >
                <Header style={{ backgroundColor: '#ffffff' }}>
                    {dimensions['width'] > 1102 ? <>
                        <Row justify={'center'} >
                            <Col >
                                <Menu
                                    theme="light"
                                    mode="horizontal"
                                    defaultSelectedKeys={['/officialweb']}
                                    selectedKeys={selecte_keys}
                                    onSelect={onSelect}
                                    right
                                    disabledOverflow
                                    items={item}
                                />
                            </Col>
                        </Row>
                    </> :
                        <>
                            <Row justify={'space-between'}>
                                <Col >
                                    <MenuOutlined
                                        onClick={e => { setCollapsed(!collapsed) }}
                                        style={{
                                            marginBottom: 16,
                                            cursor: 'pointer'
                                        }} />
                                </Col>
                            </Row>
                        </>}
                </Header>
                <Content
                    style={{
                        padding: '30px 50px',
                        fontSize: "18px",
                        // background: '#f5f5f5'
                        background: '#FFFFFF'
                    }}
                >
                    {collapsed && (<Menu
                        mode="inline"
                        defaultSelectedKeys={['/']}
                        selectedKeys={selecte_keys}
                        onClick={onSelect}
                        items={item}
                        style={{
                            whiteSpace: 'nowrap',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    />)}
                    {/* </> : null} */}
                    <Row gutter={[0, 8]}>
                        {/* {back ? <>
                            <Col span={24}>
                                <Row justify={'end'}>
                                    <Col>
                                        <Button type='primary' className='example' onClick={e => navigate('/officialWeb/admin')}>回到後台</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </> : null} */}
                        <Col span={24}>
                            <Outlet />
                        </Col>
                    </Row>
                </Content>
                <Footer
                    style={{
                        textAlign: 'center',
                    }}
                >
                    <Row justify={'end'}>
                        <Col>
                            <Button onClick={e => navigate(-1)} type='primary' className='example' style={{ display: "inline-flex", alignItems: "center" }} icon={<LogoutOutlined />}>登出</Button >
                        </Col>
                    </Row>
                </Footer >
            </Layout >
        </>
    )
}
export default MainOutlet;